import { IOrder } from './orders.repository';
import { ITeam } from './team.repository';

export interface IVerifoneSubscription {
  _id: string;
  status: VerifoneSubscriptionStatus;
  teamId: string | ITeam;
  startDate: Date;
  orderId: string | IOrder;
  subscriptionId: string;
  expirationDate: Date;
}

export enum VerifoneSubscriptionStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  PendingActivation = 'PENDING_ACTIVATION'
}
